import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { ActivatedRoute } from '@angular/router';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';

@Component({
  selector: 'app-invite-friends-modal',
  templateUrl: './invite-friends-modal.component.html',
  styleUrls: ['./invite-friends-modal.component.css']
})
export class InviteFriendsModalComponent implements OnInit {
  inviteForm: FormGroup;
  groupId: any;
  loading: boolean;

  constructor(
    public dialogRef: MatDialogRef<InviteFriendsModalComponent>,
    private gs: GroupService,
    private route: ActivatedRoute,
    private alertService: AlertPopupService,
  ) { this.route.queryParams.subscribe(params => { this.groupId = params.groupId; }); }

  ngOnInit() {
    this.inviteForm = new FormGroup({
      fname: new FormControl('', Validators.required),
      lname: new FormControl('', Validators.required),
      number: new FormControl('', Validators.required)
    });
  }


  inviteNewContact() {
    this.markFormGroupTouch(this.inviteForm);
    if (this.inviteForm.valid) {
      this.loading = true;
      this.gs.inviteGroupMemberByPhone(this.inviteForm.value, this.groupId).subscribe(res => {
        this.loading = false;
        this.dialogRef.close(true);
      }, err => {
        this.loading = false;
        this.alertService.errorAlert(err.error.message);
      });
    }
  }

  private markFormGroupTouch(form: FormGroup) {
    (<any>Object).values(form.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouch(control);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/group/components/waiting-room/invite-friends-modal/invite-friends-modal.component.ts